export default (value: number, baseLine = 16): string => `${value / baseLine}rem`
